/** @jsx jsx */
// CDS
import { css, jsx } from '@emotion/react';

import { Grid, breakpoints } from '@coursera/cds-core';

import { POST_CARD_DIMENSIONS } from 'bundles/tutorials/constants';

const styles = {
  container: () => css`
    display: block;
    position: relative;
    padding: 0 var(--cds-spacing-150);
    margin: 0 var(--cds-spacing-800) var(--cds-spacing-800);
    margin-bottom: var(--cds-spacing-800);
    overflow: hidden;
    ${breakpoints.down('xs')} {
      margin: 0 0 var(--cds-spacing-800);
    }
  `,
  hubCard: css`
    width: 716px;
    height: 256px;
    max-width: 100%;
  `,
  body: () => css`
    padding-right: var(--cds-spacing-400);
    ${breakpoints.down('xs')} {
      padding-right: 0;
      width: 387px;
      max-width: 100%;
    }

    width: 505px;
    height: 100%;
  `,
  header: () => css`
    margin-bottom: var(--cds-spacing-300);
    height: 72px;
    background: linear-gradient(to right, transparent 0%, #e8e8e8 50%, transparent 100%);
  `,
  description: css`
    width: 100%;
    height: 112px;
    background: linear-gradient(to right, transparent 0%, #e8e8e8 50%, transparent 100%);
  `,
  imageWrapper: () => css`
    border-radius: 4px;
    box-shadow: 1px 3px 8px 0 var(--cds-color-darken-300);
    height: 0;
    overflow: hidden;
    padding-bottom: ${(POST_CARD_DIMENSIONS.height / POST_CARD_DIMENSIONS.width) * 100}%;
    position: relative;
    width: 100%;
    background: linear-gradient(to right, transparent 0%, #e8e8e8 50%, transparent 100%);
    ${breakpoints.down('xs')} {
      display: none;
    }
  `,
  image: () => css`
    display: block;
    width: 100%;
    ${breakpoints.down('xs')} {
      display: none;
    }
  `,
  publishedDate: () => css`
    margin-top: var(--cds-spacing-300);
    height: 24px;
    background: linear-gradient(to right, transparent 0%, #e8e8e8 50%, transparent 100%);
  `,
};

const PostCardPlaceHolder = () => (
  <div css={styles.container} data-testid="articles_post_card_placeholder">
    <Grid container css={styles.hubCard}>
      <Grid item xs={12} sm={9} css={styles.body}>
        <div css={styles.header} />
        <p css={styles.description} />
        <div css={styles.publishedDate} />
      </Grid>

      <Grid item sm={3}>
        <div css={styles.imageWrapper}>
          <div css={styles.image} />
        </div>
      </Grid>
    </Grid>
  </div>
);

export default PostCardPlaceHolder;
